import { iSubRoute } from "../../../definitions/interfaces"

export function getNewsRoutes({ urlPrefix = "" }) {
  return routes.map((r) => ({ ...r, route: urlPrefix + r.route }))
}

const routes: iSubRoute[] = [
  {
    title: "Overview",
    route: "",
  },
  {
    title: "Description",
    route: "/description",
  },
  {
    title: "Uploads",
    route: "/manage-files",
  },
]
